import { withForm } from 'react-formed';
import Selector from 'containers/inputs/Selector';

export default withForm(Selector);
